import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTheme } from '@mui/material/styles';
import ImageAnnotationTool from './components/ImageAnnotationTool';
import VideoComponent from './videocomponent';
import ThirdCard from './cardsControllers/thirdCard';
import { IS_ANNOTATION } from '../../../store/actions';

const VideoPage = () => {
  const theme = useTheme();
  const dispatch = useDispatch();
  // const targetRef = useRef(null);
  // const [source, setSource] = useState('');
  const isAnnotation = useSelector((state) => state.cameraReducer.isAnnotation);
  const checkImage = useSelector((state) => state.cameraReducer.checkImage);

  useEffect(() => {
    if (checkImage) {
      dispatch({ type: IS_ANNOTATION, isAnnotation: true });
    }
    // eslint-disable-next-line
  }, [checkImage]);

  return (
    <div style={{ display: 'flex', backgroundColor: theme.palette.background.default }}>
      <div
        className="-m-6"
        style={{
          flex: 1,
          display: 'flex',
          flexDirection: 'column',
          height: '100vh',
          overflow: 'hidden'
        }}
      >
        <div style={{ display: 'flex', flex: 1, overflow: 'hidden' }}>
          <div style={{ flex: 1, overflow: 'hidden' }}>{isAnnotation ? <ImageAnnotationTool /> : <VideoComponent />}</div>
          {/* <RightBar /> */}
        </div>
        <div style={{ height: '200px' }}>
          <ThirdCard />
        </div>
      </div>
    </div>
  );
};

export default VideoPage;
